<!-- 发布状态详情列表 -->
<template>
  <el-dialog width="960px" title="发布状态" :visible.sync="releaseStatusVisible" showClose append-to-body center>
    <cs-table :tableCols="tableCols" :tableData="releaseStatusData" :showPagination="false" >
      <template slot-scope="scope" slot="lastPushTime">
        <span v-if="scope.row.lastPushTime">{{scope.row.lastPushTime|timeFormat}}</span>
        <span v-else>--</span>
        </template>
    </cs-table>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="releaseStatusVisible = false">关 闭</el-button>
      </span>
  </el-dialog>
</template>
<script>

export default {
  name: 'ReleaseStatus',
  props: ['releaseStatusData'],
  data () {
    return {
      tableCols: [
        { prop: 'siteAppName', label: '站点' },
        {
          prop: 'sitePushFlag',
          label: '发布进展',
          formatter: function (row, column) {
            let stateText = ''
            switch (row.sitePushFlag) {
              case 0:
                stateText = '队列中'
                break
              case 1:
                stateText = '推送中'
                break
              case 2:
                stateText = '推送失败'
                break
              case 3:
                stateText = '推送成功'
                break
              case 4:
                stateText = '已下线'
                break
              case -1:
                stateText = '未推送'
                break
              case -5:
                stateText = '回调不推送'
                break
              case -999:
                stateText = '- -'
                break
            }
            return stateText
          }
        },
        { prop: 'lastPushTime', label: '更新时间', type: 'slot' },
        { prop: 'retryTimes', label: '重试次数' }
      ],
      releaseStatusVisible: false
    }
  },
  methods: {
    open () {
      this.releaseStatusVisible = true // 打开弹出框
    }
  }
}
</script>
<style scoped>

</style>
